export const SET_TOKEN = 'SET_TOKEN';

export const SET_BACK_URL = 'SET_BACK_URL';

export const SET_USERINFO = 'SET_USERINFO';

export const SET_WX_URL = 'SET_WX_URL';

export const SET_VERIFY_CODE_TIME = 'SET_VERIFY_CODE_TIME';

export const SET_VERIFY_CODE_STATE = 'SET_VERIFY_CODE_STATE';

export const RESET_CLASS_STATE = 'RESET_CLASS_STATE';

export const SET_START_CLASS = 'SET_START_CLASS';

export const SET_END_CLASS = 'SET_END_CLASS';

export const SET_START_CLASS_RECORDID = 'SET_START_CLASS_RECORDID';

export const SET_LOADING_COUNT = 'SET_LOADING_COUNT';

// appointment module
export const SET_APPOINTMENT_BEGIN_DATE = 'SET_APPOINTMENT_BEGIN_DATE';
export const SET_APPOINTMENT_END_DATE = 'SET_APPOINTMENT_END_DATE';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js